import React, {useEffect, useState, PropsWithChildren} from 'react'
import * as R from 'ramda'
import { Button } from 'react-bootstrap'
import cx from 'classnames'
// import '_owtimeline.scss'
import moment from 'moment'

import { Workflow, WNode } from './ow/model'
import { OrderWorkflowLog } from './model-order';
import { NodeChangedEvent } from './api/order-state';

interface TimelineProps {
  workflow: Workflow
  logs: OrderWorkflowLog[]
  actions: NodeChangedEvent | null
  onExecuteAction: (id: string) => void
}

interface EventProps {
  active: boolean
  label: string
  onClick: () => void
}

const Event = ({active, label, onClick}: EventProps) => (
  <div className="ow-event" onClick={onClick}>
    <div className={cx("ow-circle", { active })}>
      {active && <div className="ow-circle-ring"></div>}
    </div>
    <div><span className={cx("ow-timeLabel", { active })}>
      { label }
    </span></div>
  </div>
)

export default function OrderTimeline(props: PropsWithChildren<TimelineProps>): JSX.Element {
  const [activeNode, setActiveNode] = useState(props.logs.length - 1)
  
  if (props.logs.length === 0 || !props.workflow) return (
    <div className="flex-row-center ow-details ow-actions">
      {props.children}
    </div>
  )

  const currentNode = R.find(R.propEq('id', props.logs[activeNode].to_node), props.workflow.nodes) as WNode

  return (
    <div className="row">
      <div className="col-12">
        <div className="flex-row-center">
          <div className="flex-row-center ow-events">
            <div className="ow-line"></div>
            { props.logs.map((log, idx) => (
              <Event key={idx}
                label={moment(log.time).format("h:mm A")}
                active={activeNode === idx} 
                onClick={() => setActiveNode(idx)}
              />
            )) }
          </div>
        </div>
        <div className="row ow-details">
          <div className="col">
            <dl className="ow-info">
              <dt>
                {currentNode.name}
                <span className="time">
                  {moment(props.logs[activeNode].time).format("LLL")}
                </span>
              </dt>
              <dd>{currentNode.description}</dd>
            </dl>
          </div>
          <div className="ow-actions">
            {props.children}
          </div>
        </div>
      </div>
    </div>
  )
}
